import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, GetListRequest, RoleDeleteRequest, RoleGetListRequest, RoleGetListResponse, RoleInsertRequest, UserDeleteRequest, UserGetListRequest, UserGetListResponse, UserInsertRequest } from '../models';
ApiUrls
@Injectable({
  providedIn: 'root'
})
export class UserService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getUsers(body: any) {

    const pageIndex = body.pageIndex || 0;
    const pageSize = body.pageSize || 10;

    // const params = new HttpParams()
    //   .set('pageIndex', pageIndex.toString())
    //   .set('pageSize', pageSize.toString());

    const link = this.apiUrl + ApiUrls.getUsers;
    return this.http.post(link, body);
  }

  getAllUsersOfRoles(roleId: number, departmentId?: number | null) {
    const link = this.apiUrl + ApiUrls.getUsers;
    const body: any = {
      pageIndex: 0,
      pageSize: 0,
      roleId,
    };

    if (Number.isFinite(departmentId) && Number(departmentId) > 0) {
      body.departmentId = Number(departmentId);
    }

    return this.http.post<any>(link, body);
  }

  getUsersWithoutInvitations(body: any) {
    const link = this.apiUrl + ApiUrls.getUsersWithoutInvitations;
    return this.http.post(link, body);
  }

  /** Unrestricted user picker for share dialogs (all depts, roles, including Super Admin). */
  getAllUserList(body: { pageIndex?: number; pageSize?: number; searchTerm?: string | null }) {
    const link = this.apiUrl + ApiUrls.getAllUserList;
    return this.http.post(link, body);
  }
  

  getAllUsers() {
    const link = this.apiUrl + ApiUrls.getUsers;
    return this.http.get(link);
  }

  getUser(id: number) {
    const link = this.apiUrl + ApiUrls.getUser + '/' + id;
    return this.http.get<any>(link);
  }


  getPermissions() {
    const link = this.apiUrl + ApiUrls.getAllPermissions;
    return this.http.get<any>(link);
  }

  getAllDelegatablePermission() {
    const link = this.apiUrl + ApiUrls.getAllDelegatablePermissions;
    return this.http.get<any>(link);
}

  insertUser(body: any) {
    const link = this.apiUrl + ApiUrls.insertUser;
    return this.http.post<BaseResponse>(link, body);
  }

  validateUserMail(body: any) {
    const link = this.apiUrl + ApiUrls.validateInvitedUser;
    return this.http.post<BaseResponse>(link, body);
  }

  inviteUser(body: any) {
    const link = this.apiUrl + ApiUrls.sendInvite;
    return this.http.post<BaseResponse>(link, body);
  }

  resendInvitationEmail(body: any) {
    const link = this.apiUrl + ApiUrls.resendInvitationEmail;
    return this.http.post<BaseResponse>(link, body);
  }

  updateUser(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateUser}/${id}`;
    return this.http.post<BaseResponse>(link, body);
  }

  deleteUser(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteUser}/${id}`;
    return this.http.get<BaseResponse>(link);
  }

  deleteInvitation(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteInvitation}/${id}`;
    return this.http.delete<BaseResponse>(link);
  }

  getRoles(body: any) {
    const link = this.apiUrl + ApiUrls.getRoles;
    return this.http.post<any>(link, body);
  }

  getRoleById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getRoleById}/${id}`;
    return this.http.get<any>(link);
  }

  insertRole(body: any) {
    const link = this.apiUrl + ApiUrls.insertRole;
    return this.http.post<BaseResponse>(link, body);
  }
  updateRole(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateRole}/${id}`;
    return this.http.post<any>(link, body);
  }
  updateRoleAndPermission(body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateRole}`;
    return this.http.post<any>(link, body);
  }
  getDelegationToken(body: any) {
    const link = this.apiUrl + ApiUrls.getDelegationToken;
    return this.http.post<any>(link, body);
  }

  deleteRole(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteRole}/${id}`;
    return this.http.post<BaseResponse>(link, { id });
  }

  getUserPermissions(body: any) {
    const link = this.apiUrl + ApiUrls.getUserPermissions;
    return this.http.post<any>(link, body);
  }

  getUserPermission(id: number) {
    const link = this.apiUrl + ApiUrls.getUserPermission;
    return this.http.post<any>(link, { id });
  }

  deleteUserPermission(id: number) {
    const link = this.apiUrl + ApiUrls.deleteUserPermission;
    return this.http.post<any>(link, { id });
  }

  getUserNotification(id: any) {
    const link = this.apiUrl + ApiUrls.getUserNotification;
    return this.http.post<any>(link, id);
  }

  updateUserNotification(body: any) {
    const link = this.apiUrl + ApiUrls.updateUserNotification;
    return this.http.post<any>(link, body);
  }

  getUserByDepartment(body: any) {
    const link = this.apiUrl + ApiUrls.getusersbydept;
    return this.http.post<any>(link, body);
  }

  getUsersByDepartments(body: any) {
    const link = this.apiUrl + ApiUrls.getusersbydepts;
    return this.http.post<any>(link, body);
  }
  activateOrdeactivateUser(userId:number, actOrDeact:string){
    const link = this.apiUrl + ApiUrls.activateDeactivateUser(userId,actOrDeact);
    return this.http.post<any>(link, {});
  }

  updateCurrentUserProfile(body: any) {
    const link = this.apiUrl + ApiUrls.updateCurrentUserProfile;
    return this.http.post<BaseResponse>(link, body);
  }

  getCurrentUserProfileImage() {
    const link = this.apiUrl + ApiUrls.getCurrentUserProfileImage;
    return this.http.get<BaseResponse>(link);
  }

  
}
